import { useState, useEffect } from 'react';
import { Badge } from 'antd';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useQuery } from '@tanstack/react-query';
import { t } from '../../i18n/i18n';
import NotificationsEmpty from '../../assets/header/notifications-empty';
import { getNotifications } from '../../API/services/notificationService';
import './DropdownNotification.scss';
import NotificationCenter from '../NotificationCenter/NotificationCenter';

const DropdownNotification = ({ className }) => {
  const [showNotificationCenter, setShowNotificationCenter] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const { data: unreadCountData } = useQuery({
    queryKey: ['notifications-unread-count'],
    queryFn: async () => {
      const response = await getNotifications({
        limit: 1,
        read: 'unread',
      });
      return response?.pagination?.total || 0;
    },
    enabled: true,
    refetchInterval: 30000,
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnWindowFocus: false,
  });

  // Actualizar unreadCount cuando cambie unreadCountData
  useEffect(() => {
    if (unreadCountData !== undefined) {
      setUnreadCount(unreadCountData);
    }
  }, [unreadCountData]);

  const handleNotificationClick = () => {
    setShowNotificationCenter(true);
  };

  const handleUnreadCountChange = (count) => {
    setUnreadCount(count);
  };

  return (
    <>
      <div
        className={`d-flex align-self-end align-self-sm-center dropdown-lang-max-height`}
      >
        <div
          className={` rounded  font-weight-bold non-selectable dropdown-lang-select-container position-relative w-max-content ${className}`}
        >
          <div
            onClick={handleNotificationClick}
            aria-hidden
            className="dropdown-lang-select-button cursor-pointer p-2 w-100 d-flex align-items-center justify-content-between position-relative"
          >
            {unreadCount > 0 ? (
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="notification-tooltip">
                    {t('NOTIFICATIONS_NEW') || 'You have new notifications'}
                  </Tooltip>
                }
              >
                <Badge dot={true} offset={[-5, 5]}>
                  <NotificationsEmpty color={showNotificationCenter ? '#000' : 'grey'} />
                </Badge>
              </OverlayTrigger>
            ) : (
              <Badge dot={false} offset={[-5, 5]}>
                <NotificationsEmpty color={showNotificationCenter ? '#000' : 'grey'} />
              </Badge>
            )}
          </div>
        </div>
      </div>
      <NotificationCenter 
        visible={showNotificationCenter} 
        onClose={() => setShowNotificationCenter(false)}
        onUnreadCountChange={handleUnreadCountChange}
      />
    </>
  );
};

export default DropdownNotification;
